/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Grid from '@mui/material/Grid';
import { TextV2 } from '@insights-ltd/design-library/components';
import { Trans, useTranslation } from 'react-i18next';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { Group, PractitionerData } from 'api';
import OrganisationGroupLink from 'components/OrganisationGroupLink/OrganisationGroupLink';
import { roleDescription } from 'pages/Organisation/OrganisationPractitioners/helper';
import {
  BoldDataText,
  GroupDescription,
  IconWrapper,
  OrganisationCardIcon,
  OrganisationIconHeader,
  OrganisationTitle,
  RoleText,
} from './StyledComponents';

type OrganisationInfoCardProps = {
  id: string;
  name: string;
  group?: Group;
  practitioner?: PractitionerData;
  icon?: OrganisationCardIcon | null;
};

const OrganisationInfoCard: React.FC<OrganisationInfoCardProps> = ({
  id,
  name,
  group,
  practitioner,
  icon = 'Organisation',
}) => {
  const { t } = useTranslation();
  return (
    <Grid
      sx={(theme) => ({
        display: 'flex',
        margin: `0 ${theme.spacing(spacingSizeMap.XS)} ${theme.spacing(
          spacingSizeMap.XS,
        )} 0`,
        padding: `${theme.spacing(spacingSizeMap.S)}`,
        border: `1px solid ${theme.palette.grey[400]}`,
        borderRadius: '0.25rem',
        flexDirection: 'column',
      })}
      key={id}
      size={{ xs: 12, md: 5 }}
    >
      <OrganisationIconHeader>
        <IconWrapper iconType={icon} />
        <OrganisationTitle component="p" variant="h4">
          {name}
        </OrganisationTitle>
      </OrganisationIconHeader>
      <Grid>
        <GroupDescription>
          <span>
            {group ? <OrganisationGroupLink group={group} kind="bold" /> : null}
          </span>
        </GroupDescription>
        <div>
          {practitioner ? (
            <TextV2 component="p">
              <Trans
                i18nKey="ui.event-management.account.role"
                components={{
                  '1': <BoldDataText />,
                  '2': <RoleText />,
                }}
                values={{ role: t(roleDescription(practitioner!.role)) }}
              />
            </TextV2>
          ) : null}
        </div>
      </Grid>
    </Grid>
  );
};

export default OrganisationInfoCard;
/* eslint-enable @typescript-eslint/no-non-null-assertion */
